import { isAppreciationPeriod } from "utils/method";
import { DELIVERY_URI } from "config/const";

export function handleDeliveryUri(orders) {
  orders
    .filter(
      ({ DELIVERY_STATUS, SHIPPING_NO }) =>
        DELIVERY_STATUS === "已發貨" && SHIPPING_NO
    )
    .forEach((order) => {
      switch (order.DELIVERY) {
        case "7-11":
          order.deliveryUri = DELIVERY_URI.SEVEN;
          break;
        case "family":
          order.deliveryUri = DELIVERY_URI.FAMILY;
          break;
        case "宅配":
          order.deliveryUri = DELIVERY_URI.HOME;
          break;
        default:
          break;
      }
    });
  return orders;
}
export function handleEnabledRefund(orders, appreciationPeriodDay) {
  orders.forEach((order) => {
    const enableRefund =
      !order.REFUND_DETAIL &&
      order.ORDER_STATUS !== "退貨處理中" &&
      order.PAYMENT_STATUS === "已付款" &&
      order.PAYMENT !== "信用卡(分期付款)" &&
      isAppreciationPeriod(order.TIME, appreciationPeriodDay);
    order.ENABLE_REFUND = enableRefund;
  });
  return orders;
}
